export default __webpack_public_path__ + "static/media/our-partner-logo-12.8fcc8003.jpeg";